/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from "react";
import "./style.scss";
import {
  Row,
  Col,
  Empty,
  Select,
  Button,
  Space,
  Divider,
  Form,
  message,
  Tabs,
  Tooltip,
} from "antd";
import PropTypes from "prop-types";
import backArrow from "../../../assests/images/backarrow.svg";
import useCustomNavigate from "../../../components/customNavigationHook";
import { ManifestCard } from "./ManifestCard";
import { ManifestMiniCard } from "./ManifestMiniCard";
import ScannedShipment from "../../../components/ScannedShipment";
import back_img from "../../../assests/images/rightVector.svg";
import { capitaliseWithHyphen } from "../../../utils";
import { InfoCircleOutlined } from "@ant-design/icons";
import Heading from "../../../components/Heading";
import API from "../../../api";
import urls from "../../../api/urls";
const {
  ELIGIBLE_MANIFEST_LIST,
  CP_EWAY_BILL_TABLE,
  PATCH_SHIPMENTS_TO_LOAD,
  CREATE_MANIFEST_NEW,
  ELIGIBLE_WEEK_MANIFEST_LIST,
  GET_CLIENT_LIST_NEW,
  GET_CLIENT_INNO,
} = urls;

function ManifestList({
  name,
  // packet,
  // individual,
  color,
  children,
  packetStatus,
  shipmentStatus,
  packetAndShipmate,
  manifestFor,
  handleScanCallback,
  handleRemoveScanCallback,
  totalScannedShipment,
  checkEligibleEmpty,
  checkScanEmpty,
  handleFilter,
  setClient,
  setTodayData,
  pastPendingCount,
  todayPendingCount,
}) {
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpen3, setDropdownOpen3] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [department, setDepartment] = useState([]);
  const [clientId, setClientID] = useState(null);
  const [activeKey, setActiveKey] = useState(1);
  const [destroy, setDestroy] = useState(false);

  const currentEnv = process.env.REACT_APP_ENV;

  const navigate = useCustomNavigate();
  const [form] = Form.useForm();

  // console.log(checkScanEmpty, "checkScanEmpty");
  // console.log(checkEligibleEmpty, "checkEligibleEmpty");

  const DocType = [
    {
      value: "Dox",
      label: "Dox",
    },
    {
      value: "Non-Dox",
      label: "Non-Dox",
    },
  ];

  const shipmentMode = [
    {
      value: "Air",
      label: "Air",
    },
    {
      value: "Surface",
      label: "Surface",
    },
  ];

  const shipmentType = [
    {
      value: "standard",
      label: "Standard",
    },
    {
      value: "fast track",
      label: "Fast track",
    },
    {
      value: "value plus",
      label: "Value plus",
    },
    {
      value: "vayuquick",
      label: "Vayu quick",
    },
    {
      value: "vayuquick_pro",
      label: "Vayu quick pro",
    },
  ];

  useEffect(() => {
    !name.includes("Scanned") && getClients();
  }, []);

  useEffect(() => {
    if (clientId) {
      setClient(clientId);
    }
  }, [clientId]);

  const [filters, setFilters] = useState({
    type: null,
    travel: null,
    typeOpen: false,
    travelOpen: false,
    shipmentType: null,
    shipmentTypeOpen: false,
  });

  const changeTab = (key) => {
    setActiveKey(key);
    setDestroy(false);
    setTodayData(key === 1 ? true : false);
  };

  function onChange(params, p2) {
    if (p2 == "type") {
      setFilters((prev) => ({ ...prev, type: params }));
    }
    if (p2 == "travel") {
      setFilters((prev) => ({ ...prev, travel: params }));
    }
    if (p2 == "shipmentType") {
      setFilters((prev) => ({ ...prev, shipmentType: params }));
    }
  }

  useEffect(() => {
    if (filters?.type || filters?.travel || filters?.shipmentType) {
      handleFilter(
        filters?.type?.toLowerCase(),
        filters?.travel?.toLowerCase(),
        filters?.shipmentType?.toLowerCase()
      );
    }
  }, [filters]);

  const handleClear = (item) => {
    if (item == "type") {
      setFilters((prev) => ({
        ...prev,
        type: null,
      }));
      setDropdownOpen(false);
    }

    if (item == "travel") {
      setFilters((prev) => ({
        ...prev,
        travel: null,
      }));
      setDropdownOpen2(false);
    }

    if (item == "shipmentType") {
      setFilters((prev) => ({
        ...prev,
        shipmentType: null,
      }));
      setDropdownOpen3(false);
    }

    handleFilter("clear");
  };

  const getClients = async () => {
    const companyId =
      JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;
    let res;
    if (currentEnv === "qa") {
      res = await API.Api(
        GET_CLIENT_LIST_NEW + companyId
      ).getWithPremiseHeader();
    } else {
      res = await API.Api(GET_CLIENT_INNO).getwithParams({
        company_id: companyId,
      });
    }

    if (res.status) {
      const response = res?.response?.data?.data || [];
      const clients = response?.map((e, i) => ({
        key: i,
        label: capitaliseWithHyphen(e?.ClientName),
        value: e?.ClientName,
        department: e?.Departments,
      }));
      // localStorage.setItem("allClients", JSON.stringify(clients) || null);
      setClientList(clients);
    } else {
      message.error("Something went wrong");
    }
  };
  const getDepartMentQA = async (selectedClient, selectedDepartment) => {
    form.setFieldsValue({
      department: null,
    });

    const currentDepartment = selectedDepartment
      ? [selectedDepartment?.item]
      : selectedClient?.department || [];

    if (selectedClient) {
      setDepartment(
        selectedClient?.department?.map((item, i) => ({
          key: i,
          value: i,
          label: getDepartmentContactName(item),
          item: item,
        }))
      );
    }
    const item = currentDepartment[0];
    const mergeName = getDepartmentContactName(item);

    form.setFieldsValue({
      department: mergeName,
    });
    setClientID(item?.ClientID);
  };
  const getDepartmentContactName = (item) => {
    let departmentName =
      item?.Department && item?.Department !== ""
        ? item?.Department
        : "Default";

    let contactName =
      item?.ContactPerson && item?.ContactPerson !== ""
        ? "-" + item?.ContactPerson
        : "";

    if (contactName !== "" && departmentName === "Default") {
      departmentName = "";
      contactName =
        item?.ContactPerson && item?.ContactPerson !== ""
          ? item?.ContactPerson
          : "";
    }

    return departmentName + contactName;
  };

  const setClientDepartment = async (selectedClient, selectedDepartment) => {
    form.setFieldsValue({
      department: null,
    });

    const currentDepartment = selectedDepartment
      ? [selectedDepartment?.item]
      : selectedClient?.department || [];

    if (selectedClient) {
      setDepartment(
        selectedClient?.department?.map((item, i) => ({
          key: i,
          value: i,
          label: getDepartmentContactName(item),
          item: item,
        }))
      );
    }
    const item = currentDepartment[0];
    const mergeName = getDepartmentContactName(item);

    form.setFieldsValue({
      department: mergeName,
    });
    setClientID(item?.ClientID);
  };

  return (
    <div className="scan-container" style={{ position: "relative" }}>
      <div className="scan-container-header">
        {/* <span className="scan-container-header-backArrow">
            {name == "Manifest List" ? (
              <img src={backArrow} onClick={routeHandler} />
            ) : (
              ""
            )}
          </span>
          {name} */}
        {!name.includes("Scanned") ? (
          // <Heading title={name} />
          <Form form={form} className="global-form d-flex">
            <Row gutter={10}>
              <Col span={12}>
                <Form.Item name="clientName">
                  <Select
                    placeholder="Select client"
                    showSearch
                    allowClear
                    onSelect={(value, obj) => {
                      if (currentEnv == "qa") {
                        getDepartMentQA(obj);
                      } else {
                        setClientDepartment(obj);
                      }
                    }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    defaultActiveFirstOption
                    options={clientList}
                  ></Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="department">
                  <Select
                    allowClear
                    showAction={["focus", "click"]}
                    placeholder="Select department"
                    options={department}
                    onSelect={(value, obj) => {
                      setClientDepartment(null, obj);
                    }}
                  ></Select>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item>
                  <Select
                    open={dropdownOpen} // Control dropdown visibility
                    onDropdownVisibleChange={(open) => setDropdownOpen(open)}
                    showSearch
                    value={filters?.type}
                    optionFilterProp="children"
                    onChange={(val) => onChange(val, "type")}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder="Select type"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                        <Space
                          style={{
                            padding: "0 8px 4px",
                          }}
                        >
                          <Button
                            onClick={() => handleClear("type")}
                            type="link"
                            style={{ margin: "-10px" }}
                          >
                            Clear
                          </Button>
                        </Space>
                      </>
                    )}
                    options={DocType}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item>
                  <Select
                    open={dropdownOpen2} // Control dropdown visibility
                    onDropdownVisibleChange={(open) => setDropdownOpen2(open)}
                    showSearch
                    value={filters?.travel}
                    optionFilterProp="children"
                    onChange={(val) => onChange(val, "travel")}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder="Select travel"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                        <Space
                          style={{
                            padding: "0 8px 4px",
                          }}
                        >
                          <Button
                            onClick={() => handleClear("travel")}
                            type="link"
                            style={{ margin: "-10px" }}
                          >
                            Clear
                          </Button>
                        </Space>
                      </>
                    )}
                    options={shipmentMode}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item>
                  <Select
                    open={dropdownOpen3} // Control dropdown visibility
                    onDropdownVisibleChange={(open) => setDropdownOpen3(open)}
                    showSearch
                    value={filters?.shipmentType}
                    optionFilterProp="children"
                    onChange={(val) => onChange(val, "shipmentType")}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder="Select service"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                        <Space
                          style={{
                            padding: "0 8px 4px",
                          }}
                        >
                          <Button
                            onClick={() => handleClear("shipmentType")}
                            type="link"
                            style={{ margin: "-10px" }}
                          >
                            Clear
                          </Button>
                        </Space>
                      </>
                    )}
                    options={shipmentType}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        ) : (
          <h3>
            <b>Scanned manifest list</b>
          </h3>
        )}

        {/* {checkEligibleEmpty && <Empty />} */}
        {name?.includes("Scanned") ? (
          <div className="scan-container-header-packetContainer">
            {/* <span className="scan-item">Packets :</span>
          <span className="scan-item-val">{packet}</span>
          <span className="scan-item">Individual :</span>
          <span className="scan-item-val">{individual}</span> */}
            <ScannedShipment
              scannedData={totalScannedShipment}
              totalData={todayPendingCount + pastPendingCount || 0}
            />
          </div>
        ) : null}
      </div>

      <div className="scan-container-header-line"></div>
      <div className="scan-container-div">
        {name === "" && (
          <Tabs
            activeKey={activeKey}
            type="card"
            onChange={changeTab}
            className="rate-card-tab"
            items={[
              {
                label: <span>Today Shipment</span>,
                key: 1,
                children: (
                  <Row span={24} className="mt-05">
                    {packetAndShipmate?.map((el, idx) => {
                      if (
                        Object.keys(el)?.includes("packetBarcode") &&
                        el?.status === packetStatus
                      ) {
                        return (
                          <Col span={12} key={idx}>
                            <ManifestCard color={color} item={el} />
                          </Col>
                        );
                      }
                      if (
                        Object.keys(el)?.includes("awbNumber") &&
                        el?.status == shipmentStatus
                      ) {
                        return (
                          <Col span={12} key={idx}>
                            <ManifestMiniCard
                              name={name}
                              checkScanEmpty={checkScanEmpty}
                              checkEligibleEmpty={checkEligibleEmpty}
                              handleScanCallback={handleScanCallback}
                              handleRemoveScanCallback={
                                handleRemoveScanCallback
                              }
                              color={color == "yello" ? "skyblue" : color}
                              item={el}
                            />
                          </Col>
                        );
                      }
                    })}
                  </Row>
                ),
              },
              {
                label: (
                  <span>
                    Pending Shipment ({pastPendingCount})
                    <Tooltip title="Shows pending shipments from the last 7 days">
                      <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                    </Tooltip>
                  </span>
                ),
                key: 2,
                children: (
                  <Row span={24} className="mt-05">
                    {packetAndShipmate?.map((el, idx) => {
                      if (
                        Object.keys(el)?.includes("packetBarcode") &&
                        el?.status === packetStatus
                      ) {
                        return (
                          <Col span={12} key={idx}>
                            <ManifestCard color={color} item={el} />
                          </Col>
                        );
                      }
                      if (
                        Object.keys(el)?.includes("awbNumber") &&
                        el?.status == shipmentStatus
                      ) {
                        return (
                          <Col span={12} key={idx}>
                            <ManifestMiniCard
                              name={name}
                              checkScanEmpty={checkScanEmpty}
                              checkEligibleEmpty={checkEligibleEmpty}
                              handleScanCallback={handleScanCallback}
                              handleRemoveScanCallback={
                                handleRemoveScanCallback
                              }
                              color={color == "yello" ? "skyblue" : color}
                              item={el}
                            />
                          </Col>
                        );
                      }
                    })}
                  </Row>
                ),
              },
            ]}
          />
        )}
        <Row gutter={12}>
          {checkScanEmpty?.length == 0 && (
            <div className="d-flex" style={{ margin: "auto" }}>
              <Empty
                style={{ textAlign: "center", marginTop: "30%" }}
                description="No shipments scanned"
              />
            </div>
          )}
          {checkEligibleEmpty?.length == 0 && (
            <div className="d-flex" style={{ margin: "auto" }}>
              <Empty
                style={{ textAlign: "center", marginTop: "30%" }}
                description="No shipments"
              />
            </div>
          )}
          {name === "Scanned shipments" &&
            packetAndShipmate &&
            packetAndShipmate?.map((el, idx) => {
              if (
                Object.keys(el)?.includes("packetBarcode") &&
                el?.status === packetStatus
              ) {
                return (
                  <Col span={12} key={idx}>
                    <ManifestCard color={color} item={el} />
                  </Col>
                );
              }
              if (
                Object.keys(el)?.includes("awbNumber") 
              ) {
                return (
                  <Col span={12} key={idx}>
                    <ManifestMiniCard
                      name={name}
                      checkScanEmpty={checkScanEmpty}
                      checkEligibleEmpty={checkEligibleEmpty}
                      handleScanCallback={handleScanCallback}
                      handleRemoveScanCallback={handleRemoveScanCallback}
                      color={color == "yello" ? "skyblue" : color}
                      item={el}
                    />
                  </Col>
                );
              }
            })}
        </Row>
        <div className="scan-container-div-childern">{children}</div>
      </div>
    </div>
  );
}
ManifestList.PropTypes = {
  name: PropTypes.string,
  packet: PropTypes.string,
  individual: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.object,
};

export default ManifestList;
